WiseMetering.Views.ImportOrganizationData = WiseMetering.Views.Modal.Custom.extend({
    MAX_FILE_SIZE: 128 * 1024 * 1024,

    buttons: ['ok', 'cancel'],
    className: 'mbx-info text-left',
    template: 'templates/organizations/import_organization_data',
    title: () => i18next.t('import_organization_data.title'),
    width: 760,

    events: {
        'change #file': 'onFileChange',
        'change #type-select': 'onTypeChange'
    },

    onRender: function () {
        this.onTypeChange();
    },

    onFileChange: function () {
        const files = this.$('#file').prop('files');
        if (files[0] && files[0].size > this.MAX_FILE_SIZE) {
            alert(i18next.t('upload_data.file_size_error', { size: this.MAX_FILE_SIZE / 1024 / 1024 }));
            this.$('#file').val('');
        }
    },

    onTypeChange: function () {
        const type = this.$('#type-select').val();
        this.$('#sample-link').attr('href', `${WiseMetering.apiUrl}/static/example_${type}.csv`);
        const categoryLabel = this.$('#type-select option:selected').text().trim();
        this.$('#sample-instruction').html(i18next.t('import_organization_data.sample_file_instruction', {
            category: `<b>${categoryLabel}</b>`,
            interpolation: { escapeValue: false }
        }));

        let notesHtml = '';

        const baseNotes = i18next.t('organizations.configuration.import.base', { returnObjects: true });
        if (baseNotes && typeof baseNotes === 'object') {
            Object.values(baseNotes).forEach(note => {
                notesHtml += `<li>- ${note}</li>`;
            });
        }

        const typeNotes = i18next.t(`organizations.configuration.import.${type}`, { returnObjects: true });
        if (typeNotes && typeof typeNotes === 'object') {
            Object.values(typeNotes).forEach(note => {
                notesHtml += `<li>- ${note}</li>`;
            });
        }

        this.$('#import-notes').html(notesHtml);
    },

    ok: function () {
        this.block();
        this.$('#errors').empty();

        const errors = [];
        const formData = new FormData();

        const type = this.$('#type-select').val();

        const file = this.$('#file').prop('files')[0];
        if (!file) {
            errors.push(i18next.t('upload_data.upload_file_error'));
        }

        if (errors.length > 0) {
            this.showErrors(errors);
            this.unblock();
            return;
        }

        formData.append('file', file);

        const promise = $.ajax({
            contentType: false,
            data: formData,
            processData: false,
            type: 'POST',
            url: `/${type}/import?organization_id=${WiseMetering.currentOrganization.id}`
        });

        promise.always(() => {
            this.unblock();
        });
        promise.done(function (data) {
            WiseMetering.layout.showTipper('success', data.message);
            this.close();
        }.bind(this));
        promise.fail(function (data) {
            let json = { errors: [i18next.t('upload_data.server_error')] };
            try {
                json = JSON.parse(data.responseText);
            } catch (error) {
            }
            let errors = ['Unknown errors'];

            if (json.error) {
                errors = [json.error];
            } else if (json.errors) {
                errors = json.errors;
            }

            this.showErrors(errors);
        }.bind(this));
    },

    showErrors: function (list) {
        this.$('#errors').html(list.join('<br/>') + '<br/><br/>');
    }
});
